module.exports = "//public.getcloudapp.com/packs/media/images/zight-logo-dashboard-414f92be5a13dddab379cf55d7301d96.svg";